import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface CustomerState {
  selectedCustomerId: number | null
}

const initialState: CustomerState = {
  selectedCustomerId: null
}

const customerSlice = createSlice({
  name: 'selectedCustomer',
  initialState,
  reducers: {
    setSelectedCustomerId: (state, action: PayloadAction<number>) => {
      state.selectedCustomerId = action.payload
    },
    clearSelectedCustomerId: (state) => {
      state.selectedCustomerId = null
    }
  }
})

export const { setSelectedCustomerId, clearSelectedCustomerId } = customerSlice.actions
export default customerSlice.reducer
